import React, {useEffect} from "react"
import {withStyles} from "@material-ui/core/styles"
import Dialog from "@material-ui/core/Dialog"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import MuiDialogContent from "@material-ui/core/DialogContent"
import MuiDialogActions from "@material-ui/core/DialogActions"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import "./index.scss"

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    textAlign: "center",
  },
  closeButton: {
    position: "absolute",
    right: 16,
    top: 24,
    color: "var(--modes-on-primary-container)",
  },
})

const DialogTitle = withStyles(styles)((props) => {
  const {children, classes, onClose, ...other} = props
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <h6>{children}</h6>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  )
})

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    justifyContent: "center",
  },
}))(MuiDialogActions)

const DiscoveryModal = ({
  open,
  handleClickOpen,
  handleClose,
  modalTitle,
  modalBody,
  modalActions,
  modalClassName,
}) => {
  const modalClasses = "discovery_modal " + modalClassName
  useEffect(() => {}, [open])
  return (
    <Dialog
      onClose={handleClose}
      open={open}
      maxWidth="lg"
      aria-labelledby="customized-dialog-title"
      className={modalClasses}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        {modalTitle}
      </DialogTitle>
      <DialogContent>{modalBody}</DialogContent>
      <DialogActions>{modalActions}</DialogActions>
    </Dialog>
  )
}

export default DiscoveryModal
